import { useContext, useMemo } from 'react'
import {
  buildPanelCheckItems,
} from 'components/Cruises/SearchPage/Filters/Inputs/CruiseExtraFiltersInputs'
import FilterPanelCheckboxGroup from 'components/Common/FilterPanel/FilterPanelCheckboxGroup'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'

import { trackEvent } from 'analytics/analytics'
import { mapCruiseLineFilterToSnowplowSearchEvent } from 'analytics/mapSnowplowSearchTracking'
import { searchEventWithContext } from 'analytics/snowplow/events'
import { CRUISE_TRAVELLER_TYPE_FILTER_FACETS, CruiseTravellerType } from 'constants/cruise'
import { type IntlShape, useIntl } from 'react-intl'

interface Props {
  travellerTypes?: Set<string>
  onChange: (value: any) => void
}

function CruiseTravellerTypeFilter({
  travellerTypes,
  onChange,
}: Props) {
  const globalSearchState = useContext(GlobalSearchStateContext)
  const intl = useIntl()

  const travellerTypeItems = useMemo(() => {
    return buildPanelCheckItems(CRUISE_TRAVELLER_TYPE_FILTER_FACETS.map(facet => ({
      ...facet,
      label: getTravellerTypeLabel(intl, facet.slug),
    })))
  }, [intl])

  return <div data-testid="cruise-traveller-type-filter">
    <FilterPanelCheckboxGroup
      name="travellerTypes"
      items={travellerTypeItems}
      onChange={(e) => {
        trackEvent(searchEventWithContext({
          searchEvent: { type: 'filters' },
          sortContext: { value: 'recommended' },
          searchContext: mapCruiseLineFilterToSnowplowSearchEvent(globalSearchState),
          filterContexts: [{
            label: e.target.value,
            type: 'traveller_type',
            value: e.target.checked ? 'selected' : 'unselected',
          }],
        }))

        onChange(e)
      }}
      defaultSelected={travellerTypes}
    />
  </div>
}

export default CruiseTravellerTypeFilter

function getTravellerTypeLabel(intl: IntlShape, travellerType: string): string {
  switch (travellerType) {
    case CruiseTravellerType.ROMANTIC:
      return intl.formatMessage({
        id: 'wOwhXmxR26X9Pil0LDOv',
        defaultMessage: 'Romantic',
        description: 'Traveller type filter option for romantic cruises in cruise search filters',
      })
    case CruiseTravellerType.FAMILY:
      return intl.formatMessage({
        id: 'b_29oiECh-QhhsRnDuKS',
        defaultMessage: 'Family & group',
        description: 'Traveller type filter option for family and group cruises in cruise search filters',
      })
    case CruiseTravellerType.SINGLES:
      return intl.formatMessage({
        id: 'iz0fiKdVfksAWBH3f290',
        defaultMessage: 'Singles',
        description: 'Traveller type filter option for solo travellers in cruise search filters',
      })
    default:
      return travellerType
  }
}
